


















































































































































































/* eslint-disable */
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import CalculadoraVuex from '@/store/CalculadoraVuex'

@Component

export default class ComponentCalculadoraDialogSelectTabela extends Vue {
  @Prop(Boolean) show
  @Prop(Object) valorConsolidado
  @Prop(Object) calculadora

  cirurgiao: Number = 100
  valorAux1: Number = 30
  valorAux2: Number = 20
  valorAux3: Number = 20
  valorAux4: Number = 20
  instrumentador: Number = 10
  isEnableCalcular: Boolean = false

  set getShowDialogShowValores(value) {
    CalculadoraVuex.dispatch('SET_SHOW_CACULADORA_DIALOG_SHOW_VALORES', value)
  }

  get getShowDialogShowValores() {

    if (this.getTabelaPrecoVersao === 'CBHPM2018' && !this.ativarValoresTabelaCBHPM) {
      this.loadTabela2018()
    }
    else {
      this.loadTabelaDefault()
    }

    return CalculadoraVuex.getters.SHOW_CACULADORA_DIALOG_SHOW_VALORES
  }

 get ativarValoresTabelaCBHPM() {
   return CalculadoraVuex.getters.ATIVAR_VALORES_TABELA_CBHPM
 }

  get getTabelaPrecoVersao() {
    return CalculadoraVuex.getters.TABELA_PRECO_VERSAO
  }

  get isEnableSave() {
    return this.isEnableCalcular
  }

  calcularValores() {
    this.isEnableCalcular = true
  }

  loadTabela2018() {
    this.cirurgiao = 100
    this.valorAux1 = 60
    this.valorAux2 = 40
    this.valorAux3 = 30
    this.valorAux4 = 30
  }

  loadTabelaDefault() {
    this.cirurgiao = 100
    this.valorAux1 = 30
    this.valorAux2 = 20
    this.valorAux3 = 20
    this.valorAux4 = 20
  }

  @Emit('change')
  change() {

    this.calculadora.fatorCirurgiao = Number(this.cirurgiao) / 100
    this.calculadora.fatorAux1 = Number(this.valorAux1) / 100
    this.calculadora.fatorAux2 = Number(this.valorAux2) / 100
    this.calculadora.fatorAux3 = Number(this.valorAux3) / 100
    this.calculadora.fatorAux4 = Number(this.valorAux4) / 100
    this.calculadora.fatorInstrumentador = Number(this.instrumentador) / 100
    this.isEnableCalcular = false
  }

  @Emit('close')
  close() { }

  multiply: Number = 1
}
